import { ApolloProvider } from '@apollo/client';
import createApolloClient from 'services/apolloClient';

const ApolloClientProvider = ({ children }: any) => (
	<ApolloProvider client={createApolloClient()}>{children}</ApolloProvider>
);

export default ApolloClientProvider;
